import {useEffect, useState} from 'react'
import {HubConnectionBuilder, LogLevel} from '@microsoft/signalr'
import actions from 'redux-auto'
import {Module} from 'ag-common/constants/modules'
import useCurrentUser from '#hooks/store/useCurrentUser'
import useUserModuleSettings from '#hooks/useUserModuleSettings'
import { getAccessToken } from '#services/storage'

const connection = new HubConnectionBuilder()
  .withUrl('/hubs/chat', {
    accessTokenFactory: () => getAccessToken(),
  })
  .configureLogging(LogLevel.Information)
  .withAutomaticReconnect()
  .build()

export function SignalRConnector() {
  const {isLoggedIn} = useCurrentUser()
  const {showModule} = useUserModuleSettings()
  const hasChat = showModule(Module.chat)
  const [isConnected, setIsConnected] = useState(false)

  useEffect(() => {
    async function start() {
      try {
        connection.on('NewChatActivity', chatId => {
          actions.chat.getActivities({chatId})
          actions.chat.getMyChats()
        })

        connection.on('NewChatInfo', () => {
          actions.chat.getMyChats()
        })

        connection.onclose(err => {
          if (err) {
            console.log(`SignalR closed with error: ${err}`) /* eslint-disable-line no-console */
          } else {
            console.log('SignalR closed') /* eslint-disable-line no-console */
          }

          setIsConnected(false)
        })

        await connection.start()
        setIsConnected(true)
        console.log('SignalR started') /* eslint-disable-line no-console */
      } catch (err) {
        console.log(`Start SignalR connection failed with error: ${err}`) /* eslint-disable-line no-console */
        setIsConnected(false)
      }
    }

    if (isLoggedIn && hasChat) {
      if (!isConnected) {
        start()
      }
    } else if (isConnected) {
      console.log('stopping SignalR') /* eslint-disable-line no-console */
      connection.stop()
    }
  }, [isLoggedIn, hasChat, isConnected])
  return null
}
